import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class WarehouseRestockContextOperationsResponse {
  @jsonMember(Boolean)
  public readonly canBeEdited!: boolean;

  @jsonMember(Boolean)
  public readonly canBeApproved!: boolean;

  @jsonMember(Boolean)
  public readonly canBeRejected!: boolean;

  @jsonMember(Boolean)
  public readonly canBeViewed!: boolean;
}
